import { Story } from '../../components/common/utilities/newsStoryPopupTypes';
import { getLatestStories } from '../../components/common/utilities/getLatestStories';
import {
    GetBreakingNewsStoryActionType,
    ToggleBreakingNewsActionType,
    GET_BREAKING_NEWS_STORIES,
    TOGGLE_BREAKING_NEWS } from '../actions/breakingNewsAction';

interface BreakingNewsState {
    isVisible: boolean;
    stories: Story[];
    breakingNewsStory?: Story;
    storyLoadError?: any; 
}
const initialState: BreakingNewsState = {
    isVisible: true,
    stories: []
};

type BreakingNewsActionType = ToggleBreakingNewsActionType | GetBreakingNewsStoryActionType;

export function breakingNews(state = initialState, action: BreakingNewsActionType): BreakingNewsState
{
    switch (action.type)
    {
        case TOGGLE_BREAKING_NEWS:
        {
            return {
                ...state,
                isVisible: action.payload
            };
        }

        case GET_BREAKING_NEWS_STORIES.pending:
        {
            return {
                ...state,
                breakingNewsStory: undefined,
                storyLoadError: undefined,
                stories: []
            };
        }
        case GET_BREAKING_NEWS_STORIES.fulfilled:
        {
            const breakingNewsStory = getLatestStories(action.payload) as Story;
            return {
                ...state,
                breakingNewsStory: breakingNewsStory,
                storyLoadError: undefined,
                stories: action.payload
            };
        }
        case GET_BREAKING_NEWS_STORIES.rejected:
        {
            return {
                ...state,
                breakingNewsStory: undefined,
                storyLoadError: action.payload,
                isVisible: false,
                stories: []
            };
        }
    }

    return state;
}